import { beforeEnterCmmon } from "../method/method";

// H5页面，审批
export default [
  // 审批H5
  {
    path: "/approvalH5",
    name: "approvalH5",
    beforeEnter: beforeEnterCmmon,
    redirect: "/approveH5-newApproval",
    component: () => import("@/CommonDP/pages/appView/approvalH5/index.vue"),
    children: [
      {
        // 发起审批
        path: "/approveH5-newApproval",
        name: "approveH5-newApproval",
        component: () => import("@/CommonDP/pages/appView/approvalH5/InitiateApproval/index.vue")
      },
      {
        // 我的审批
        path: "/approveH5-myApproval",
        name: "approveH5-myApproval",
        component: () => import("@/CommonDP/pages/appView/approvalH5/InitiateApproval/myApproval.vue")
      },
      {
        // 我的创建
        path: "/approveH5-myCreated",
        name: "approveH5-myCreated",
        component: () => import("@/CommonDP/pages/appView/approvalH5/InitiateApproval/myCreated.vue")
      }
    ]
  },
  // 流程页面H5
  {
    path: "/flowH5Summary",
    name: "flowH5Summary",
    beforeEnter: beforeEnterCmmon,
    component: () => import("@/CommonDP/components/processComponents/flowNewH5/flowH5Summary.vue")
  }
];
